const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6e01833d2023f938643ce3ed90bade20ecc9d9c6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["admin@fotokorner"]={id:"6e01833d2023f938643ce3ed90bade20ecc9d9c6"};
      